export const LIST_MESSAGE_CATEGORIES = {
  interaktive_list: "Interaktive List",
  product_collection_list: "Product Collections",
};

export const CONVERSATION_CHAT_PAGE_SIZE = 10;
